import React from "react";
import { useSelector } from "react-redux";
import { Card } from "rebass";
import get from "lodash/get";

import { getUser } from "../../../store/modules/session/selectors";

import { SettingsSVG } from "../svg/SettingsSVG";

export const UserIcon: React.FC = () => {
  const user = useSelector(getUser);
  const photoURL = get(user, ["photoURL"]) || undefined;

  return (
    <Card
      width="33px"
      height="33px"
      color="wild-blue"
      borderRadius="50%"
      backgroundColor="sp-gray"
      backgroundImage={`url(${photoURL})`}
      backgroundPosition="center"
      backgroundSize="contain"
      backgroundRepeat="no-repeat"
      css="display: flex; justify-content: center; align-items: center;"
    >
      {!photoURL && <SettingsSVG size={20} />}
    </Card>
  );
};
